import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import * as OrganizationActions from './organization.actions';
import * as OrganizationSelectors from './organization.selectors';
import { OrganizationState } from './organization.reducer';
import { OrganizationInterfaceWithId } from '@sk/sk-interfaces';


@Injectable()
export class OrganizationFacade {
  organizationId$ = this.store.pipe(select(OrganizationSelectors.getCurrentOrganizationId));
  organization$ = this.store.pipe(select(OrganizationSelectors.getCurrentOrganization));
  organizationIdError$ = this.store.pipe(select(OrganizationSelectors.getOrganizationIdError));
  organizationError$ = this.store.pipe(select(OrganizationSelectors.listenForOrganizationFireStoreError));
  updateOrganizationError$ = this.store.pipe(select(OrganizationSelectors.listenForOrganizationUpdateError));
  updateOrganizationSuccess$ = this.store.pipe(select(OrganizationSelectors.listenForOrganizationUpdateSuccess));


  constructor(private store: Store<OrganizationState>) {
  }

  loadOrganizationFromFirestore() {
    const organizationId = localStorage.getItem('organizationId');
    if (organizationId === undefined) {
      this.store.dispatch(OrganizationActions.getFireStoreOrganizationError({ error: new Error('Organization Id not found') }));
    } else {
      this.store.dispatch(OrganizationActions.getFireStoreOrganization({ organizationId }));
    }
  }


  setOrganizationId() {
    const organizationId = localStorage.getItem('organizationId');
    if (!organizationId) {
      this.store.dispatch(OrganizationActions.setCurrentOrganizationIdFailure({ error: new Error('Organization Id not found') }));
    } else {
      this.store.dispatch(OrganizationActions.setCurrentOrganizationId({ organizationId }));
    }
  }

  updateOrganization(organizationId: string, changes: OrganizationInterfaceWithId) {
    this.store.dispatch(OrganizationActions.updateOrganization({
      id: organizationId,
      changes
    }));
  }


}
